import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../constants/dataAids';
export function AddToCartButton({ children, state, onClick, disabled, productId, ...props }) {
  const { Button } = UX2.Element;

  return (
    <Button.Spotlight
      id={ `addtocart-btn-${productId}` }
      onClick={ onClick }
      state={ state }
      disabled={ disabled }
      data-aid={ dataAids.ADD_TO_CART }
      { ...props }
    >
      { children }
    </Button.Spotlight>
  );
}

AddToCartButton.propTypes = {
  productId: PropTypes.string,
  children: PropTypes.node.isRequired,
  state: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
